// แยกยอดบุฟเฟ่ต์ของบิลเดียวเป็นรายการ (ผู้ใหญ่/เด็ก/รีฟิลน้ำ) จาก guests + pricing snapshot ที่เก็บไว้ในบิล
// ส่วนต่างจาก buffetTotal จริง (บิลเก่าไม่มี snapshot / ปรับยอดมือ) ใส่เป็นแถว "อื่นๆ / ปรับยอด"
// เพื่อให้ผลรวมของแถวเท่ากับ buffetTotal เสมอ
export function buffetBreakdown(guests, pricing, buffetTotal = 0) {
  const g = guests && typeof guests === 'object' ? guests : {};
  const p = pricing || {};
  const h = p.heights || {};
  const adultMin = h.adultMin ?? 130;

  const lines = [
    { label: 'บุฟเฟ่ต์ผู้ใหญ่', qty: g.adults || 0, unit: p.adultPrice || 0 },
    { label: `บุฟเฟ่ต์เด็ก ${h.childBigMin ?? 120}-${adultMin} ซม.`, qty: g.children130 || 0, unit: p.child130Price || 0 },
    { label: `บุฟเฟ่ต์เด็ก ${h.childSmallMin ?? 100}-${h.childBigMin ?? 120} ซม.`, qty: g.children120 || 0, unit: p.child120Price || 0 },
    { label: `เด็กต่ำกว่า ${h.childSmallMin ?? 100} ซม.`, qty: g.childrenUnder100 || 0, unit: p.childUnder100Price || 0 },
  ].map(l => ({ ...l, amount: l.qty * l.unit }));

  const drinkQty = p.drinkRefillCount || 0;
  const drinkAmount = p.drinkRefillTotal ?? drinkQty * (p.drinkRefillPerHead || 0);
  lines.push({
    label: p.drinkRefillLabel || 'รีฟิลน้ำไม่อั้น',
    qty: drinkQty,
    unit: p.drinkRefillPerHead || 0,
    amount: drinkAmount || 0
  });

  const rows = lines.filter(l => l.amount > 0);
  const gap = Math.round(((Number(buffetTotal) || 0) - rows.reduce((s, r) => s + r.amount, 0)) * 100) / 100;
  if (Math.abs(gap) >= 0.5) {
    rows.push({ label: 'อื่นๆ / ปรับยอด', qty: 0, unit: 0, amount: gap });
  }
  return rows;
}
